import React from 'react';
import { useLocation } from 'react-router-dom';

import EVFormPost from '../components/SelectPlan/EVFormPost';


const EVSelectPlan = () => {
    document.title="Select Plan iFrame";
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const authParam = queryParams.get('auth');
    const countryCode = queryParams.get('countryCode');
    const stateCode = queryParams.get('stateCode');
    const zipCode = queryParams.get('zipCode');
    const signature = queryParams.get('signature');

    return (
        <div>
            <EVFormPost
                token={authParam}
                countryCode={countryCode}
                stateCode={stateCode}
                zipCode={zipCode}
                signature={signature}
            />

        </div>
    );
}

export default EVSelectPlan;